import PropTypes from "prop-types";
import { ContentMenuModal } from "../Layout/templates";
import { RESOURCE_MENU_ITEMS } from "../../constants/navigation";

const ResourceMenuModal = ({ isOpen, onClose }) => {
  // Use centralized resource menu items with external link configuration
  const resourceMenuItems = RESOURCE_MENU_ITEMS;

  return (
    <ContentMenuModal
      isOpen={isOpen}
      onClose={onClose}
      title="Resources"
      icon="tg-icons-Resources"
      menuItems={resourceMenuItems}
    />
  );
};

ResourceMenuModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ResourceMenuModal;
